/**
 * The allowed sanitization group used to `sanitize` strings.
 * @type {String[]}
 */
export const SanitizationGroup = {
    BASE: 'BASE_SANITIZATION_GROUP',
    HTML: 'HTML_SANITIZATION_GROUP'
};
